// extracted by mini-css-extract-plugin
export default {"infoTooltip":"Tooltip_infoTooltip__Ge4k2"};